export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10369.b36eeaec.jpg";